import PageShell from "@/components/feature/PageShell";
import "./signup.css";
import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { usePlanCatalog } from "@/hooks/usePlanCatalog";
import { getDataClient } from "@/lib/dataClient";
import { roleHomePath, translateAuthError } from "@/hooks/useAuth";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

type Role = "ogrenci" | "veli";

const ILLER = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ankara", "Antalya",
  "Ardahan", "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik",
  "Bingöl", "Bitlis", "Bolu", "Burdur", "Bursa", "Çanakkale", "Çankırı", "Çorum",
  "Denizli", "Diyarbakır", "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir",
  "Gaziantep", "Giresun", "Gümüşhane", "Hakkari", "Hatay", "Iğdır", "Isparta", "İstanbul",
  "İzmir", "Kahramanmaraş", "Karabük", "Karaman", "Kars", "Kastamonu", "Kayseri", "Kırıkkale",
  "Kırklareli", "Kırşehir", "Kilis", "Kocaeli", "Konya", "Kütahya", "Malatya", "Manisa",
  "Mardin", "Mersin", "Muğla", "Muş", "Nevşehir", "Niğde", "Ordu", "Osmaniye",
  "Rize", "Sakarya", "Samsun", "Siirt", "Sinop", "Sivas", "Şanlıurfa", "Şırnak",
  "Tekirdağ", "Tokat", "Trabzon", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak",
];

const SINIFLAR = [
  "Okul Öncesi", "1. Sınıf", "2. Sınıf", "3. Sınıf", "4. Sınıf", "5. Sınıf",
  "6. Sınıf", "7. Sınıf", "8. Sınıf (LGS)", "9. Sınıf", "10. Sınıf", "11. Sınıf",
  "12. Sınıf (YKS)", "Mezun",
];

export default function Kayit() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [role, setRole] = useState<Role>(searchParams.get("rol")==="veli" ? "veli" : "ogrenci");
  const [status, setStatus] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  
  const billing=searchParams.get('billing')==='yearly'?'yearly':'monthly';
  const {plans}=usePlanCatalog(billing);
  const planId = searchParams.get("plan");
  const selectedPlan = plans.find((p) => p.id === planId);
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "Dersdinle";

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus(null);

    const form = e.currentTarget;
    const fd = new FormData(form);
    const email = String(fd.get("email") || "").trim();
    const password = String(fd.get("password") || "");
    const ad_soyad = String(fd.get("ad_soyad") || "").trim();
    const sehir = String(fd.get("sehir") || "").trim();
    const sinif = String(fd.get("sinif") || "").trim();
    const dogum_tarihi = String(fd.get("dogum_tarihi") || "").trim();
    const telefon = String(fd.get("telefon") || "").trim();
    const eslestirme_kodu = String(fd.get("eslestirme_kodu") || "").trim();

    if (!email || !password) return;
    if(password !== String(fd.get("password_repeat") || "")){setStatus("Şifreler eşleşmiyor.");return;}
    if(!/^(?:\+90|0090|0)?5\d{9}$/.test(telefon.replace(/[\s()-]/g,""))){setStatus("Geçerli bir cep telefonu numarası girin (05XX XXX XX XX).");return;}


    if (settings.requireStrongPassword) {
      const strong = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);
      if (!strong) {
        setStatus("Şifreniz en az 8 karakter olmalı; büyük harf, küçük harf ve rakam içermelidir.");
        return;
      }
    }

    setLoading(true);
    try {
      const dataClient = getDataClient();
      const { data, error } = await dataClient.auth.signUp({
        email,
        password,
        options: {
          data: {
            role,
            ad_soyad,
            sehir,
            sinif,
            dogum_tarihi,
            telefon,
            eslestirme_kodu,
          },
        },
      });

      if (error) {
        setStatus(translateAuthError(error.message));
        return;
      }

      // Yeni kayıt bildirimi — yöneticiye e-posta (arka planda, akışı engellemeden).
      dataClient
        .functions.invoke("send-email", {
          body: { type: "new_registration", name: ad_soyad || email.split("@")[0], email, role },
        })
        .catch(() => {});

      if (data.session) {
        // Veli kaydında eşleştirme kodu girildiyse çocuğu hemen eşleştir.
        if (role === "veli" && eslestirme_kodu) {
          // Eşleştirme başarısız olsa bile kayıt akışı kesilmez; veli daha sonra tekrar deneyebilir.
          try {
            const match = await dataClient.rpc("match_parent_to_student", { p_code: eslestirme_kodu });
            if (match.error || !match.data?.ok) {
              navigate("/veli/profil", { replace: true, state: { matchError: match.error?.message || match.data?.message || "Eşleştirme tamamlanamadı. Kodu tekrar girin." } });
              return;
            }
          } catch {
            navigate("/veli/profil", { replace: true, state: { matchError: "Hesabınız oluşturuldu ancak öğrenci eşleştirilemedi. Lütfen tekrar deneyin." } });
            return;
          }
        }
        navigate(role==='ogrenci' && planId && planId!=='ucretsiz'?`/ogrenci/paketim?plan=${encodeURIComponent(planId)}&billing=${billing}`:roleHomePath(role as never), { replace: true });
      } else {
        setStatus(
          "Kayıt başarılı! E-posta adresinize gönderilen doğrulama bağlantısına tıklayarak hesabınızı aktifleştirin, ardından giriş yapabilirsiniz."
        );
      }
    } catch {
      setStatus("Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    "mt-1.5 w-full h-11 px-3.5 rounded-md border border-background-200 bg-background-100/60 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50 focus:outline-none transition-colors";

  const labelClass = "block text-sm font-medium text-foreground-800";

  return <PageShell crumbs={[{label:'Ana Sayfa',href:'/'},{label:'Üye Ol'}]}><section className="signup-section">
  {!settings.registrationOpen ? <div className="signup-closed"><h1>Kayıtlar şu an kapalı</h1><p>Yeni üyelik kayıtları geçici olarak durduruldu. Lütfen daha sonra tekrar deneyin.</p><Link to="/giris">Giriş yap →</Link></div> : <div className="signup-card">
  <aside className="signup-story"><span className="signup-accent"/><h2>Öğrenme <em>yolculuğuna katıl.</em></h2><h3>Derslerin Sesi, Başarının Yolu...</h3><p>Konu anlatımları, soru çalışmaları ve gelişim takibiyle sıradaki adımını keşfet.</p><ul>{[['ri-play-circle-line','Kendi hızında öğren','Konuları incele, örneklerle pekiştir.'],['ri-bar-chart-line','Çalışmalarını takip et','İlerlemeni gör, hedeflerine odaklan.'],['ri-parent-line','Öğrenci ve veli için ayrı alanlar','Sana uygun hesapla yolculuğa katıl.']].map(([icon,title,description])=><li key={title}><i className={icon} aria-hidden="true"/><div><strong>{title}</strong><span>{description}</span></div></li>)}</ul><div className="signup-art" aria-hidden="true"><i className="ri-book-open-line"/><i className="ri-graduation-cap-line"/></div></aside>
  <div className="signup-form"><h1>Ücretsiz hesap oluştur</h1><p className="signup-subtitle">Sana uygun hesabı seçerek başlayalım.</p>{selectedPlan&&<p className="signup-plan">Seçilen paket: {selectedPlan.name}. Paket adımına kayıt sonrasında devam edebilirsin.</p>}
  <div className="signup-roles" role="group" aria-label="Üyelik türü"><button type="button" aria-pressed={role==='ogrenci'} onClick={()=>setRole('ogrenci')}><i className="ri-graduation-cap-line" aria-hidden="true"/><span><strong>Öğrenciyim</strong><small>Kendi hesabımla devam ediyorum.</small></span></button>{settings.allowParentRegistration&&<button type="button" aria-pressed={role==='veli'} onClick={()=>setRole('veli')}><i className="ri-parent-line" aria-hidden="true"/><span><strong>Veliyim</strong><small>Öğrencimin gelişimini takip edeceğim.</small></span></button>}</div>
              <form onSubmit={handleSubmit} className="signup-fields">
              {role === "veli" && (
                <>
                  <div>
                    <label htmlFor="kayit-ad" className={labelClass}>
                      Veli Ad Soyad
                    </label>
                    <input
                      id="kayit-ad"
                      name="ad_soyad"
                      type="text"
                      required
                      autoComplete="name"
                      placeholder="Adınız Soyadınız"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="kayit-telefon" className={labelClass}>
                      Telefon Numarası
                    </label>
                    <input
                      id="kayit-telefon"
                      name="telefon"
                      type="tel"
                      required
                      autoComplete="tel"
                      placeholder="05XX XXX XX XX"
                      className={inputClass}
                    />
                  </div>

                  <div className="signup-wide rounded-lg border border-background-200 bg-background-100/40 p-4 space-y-4">
                    <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                      <i className="ri-user-heart-line text-primary-600" aria-hidden="true"></i>
                      Çocuğunla Eşleştir
                    </p>

                    <div>
                      <label htmlFor="kayit-cocuk-kod" className={labelClass}>
                        Eşleştirme Kodu
                      </label>
                      <input
                        id="kayit-cocuk-kod"
                        name="eslestirme_kodu"
                        type="text"
                        autoComplete="off"
                        placeholder="Çocuğunuzun eşleştirme kodu"
                        className={`${inputClass} uppercase tracking-widest`}
                      />
                      <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed">
                        Çocuğunuzun hesabında otomatik oluşan eşleştirme kodunu buraya
                        yazabilirsiniz. İsterseniz bu alanı boş bırakıp üye olduktan sonra
                        panelinizden de ekleyebilirsiniz.
                      </p>
                    </div>
                  </div>
                </>
              )}

              {role === "ogrenci" && (
                <>
                  <div>
                    <label htmlFor="kayit-ad" className={labelClass}>
                      Ad Soyad
                    </label>
                    <input
                      id="kayit-ad"
                      name="ad_soyad"
                      type="text"
                      required
                      autoComplete="name"
                      placeholder="Adınız Soyadınız"
                      className={inputClass}
                    />
                  </div>

                  <div>
                    <label htmlFor="kayit-sinif" className={labelClass}>
                      Sınıfın
                    </label>
                    <select
                      id="kayit-sinif"
                      name="sinif"
                      required
                      defaultValue=""
                      className={inputClass}
                    >
                      <option value="" disabled>
                        Sınıf seçin
                      </option>
                      {SINIFLAR.map((sinif) => (
                        <option key={sinif} value={sinif}>
                          {sinif}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label htmlFor="kayit-dt" className={labelClass}>
                      Doğum Tarihi
                    </label>
                    <input
                      id="kayit-dt"
                      name="dogum_tarihi"
                      type="date"
                      required
                      className={inputClass}
                    />
                  </div>
                </>
              )}

              {role === "ogrenci" && <div><label htmlFor="kayit-telefon" className={labelClass}>İletişim / Veli Telefonu</label><input id="kayit-telefon" name="telefon" type="tel" autoComplete="tel" inputMode="tel" required maxLength={20} placeholder="05XX XXX XX XX" className={inputClass}/><p className="mt-1 text-xs text-foreground-500">Size veya velinize ulaşılabilecek cep telefonu.</p></div>}
              <div>
                <label htmlFor="kayit-sehir" className={labelClass}>
                  Yaşadığınız il
                </label>
                <select
                  id="kayit-sehir"
                  name="sehir"
                  required
                  defaultValue=""
                  className={inputClass}
                >
                  <option value="" disabled>
                    İl seçin
                  </option>
                  {ILLER.map((il) => (
                    <option key={il} value={il}>
                      {il}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label htmlFor="kayit-email" className={labelClass}>
                  E-posta
                </label>
                <input
                  id="kayit-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="email"
                  placeholder="ornek@mail.com"
                  className={inputClass}
                />
              </div>

              <div>
                <label htmlFor="kayit-sifre" className={labelClass}>
                  Şifre
                </label>
                <input
                  id="kayit-sifre"
                  name="password"
                  type="password"
                  required
                  autoComplete="new-password"
                  placeholder="En az 8 karakter"
                  className={inputClass}
                />
              </div>

              <div><label htmlFor="kayit-sifre-tekrar" className={labelClass}>Şifre tekrar</label><input id="kayit-sifre-tekrar" name="password_repeat" type="password" autoComplete="new-password" required minLength={8} className={inputClass}/></div>

              <button
                type="submit"
                disabled={loading}
                className="signup-submit signup-wide"
              >
                {loading ? "Hesap oluşturuluyor..." : "Ücretsiz üye ol →"}
              </button>

              <p className="signup-wide text-xs text-foreground-500 leading-relaxed">
                Üye olarak{" "}
                <Link to="/kullanici-sozlesmesi" className="text-primary-700 hover:text-primary-800">
                  Kullanıcı Sözleşmesi
                </Link>{" "}
                ve{" "}
                <Link to="/gizlilik-politikasi" className="text-primary-700 hover:text-primary-800">
                  Gizlilik Politikası
                </Link>
                'nı kabul etmiş olursun.
              </p>
            </form>
  {status&&<p role="status" className="signup-status">{status}</p>}<p className="signup-login">Zaten hesabın var mı? <Link to={'/giris?rol='+role}>Giriş yap</Link></p>
  </div></div>}
  <p className="signup-note">Web sitemiz ve programlarımız test aşamasındadır.</p></section></PageShell>;
}

